
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","viewBox":"0 0 28 28","fill":"#FFF","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.583 10.3c0-5.083 4.134-9.217 9.217-9.217s9.217 4.134 9.217 9.217v9.217H4.583V10.3zM13.8 3.917A6.393 6.393 0 007.417 10.3v6.383h12.766V10.3A6.393 6.393 0 0013.8 3.917z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.317 19.604v2.292l.003.007a.156.156 0 00.032.045.155.155 0 00.052.035h18.892a.156.156 0 00.052-.035.156.156 0 00.035-.052v-2.292a.156.156 0 00-.035-.052.16.16 0 00-.052-.035H4.404a.159.159 0 00-.052.035.156.156 0 00-.035.052zM1.483 19.6c0-1.583 1.334-2.917 2.917-2.917h18.9c1.583 0 2.917 1.334 2.917 2.917v2.3c0 1.583-1.334 2.917-2.917 2.917H4.4c-1.583 0-2.917-1.334-2.917-2.917v-2.3z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.217 23.4c0 2.017 1.666 3.683 3.683 3.683s3.683-1.666 3.683-3.683h2.834c0 3.583-2.934 6.517-6.517 6.517S7.383 26.983 7.383 23.4h2.834zM5.91 2.663l.002-.002.003-.001a.047.047 0 00.001-.001l-.01.008-.076.058a5.42 5.42 0 00-.322.281 7.866 7.866 0 00-1.046 1.219C3.696 5.319 2.917 6.99 2.917 9.3a1.417 1.417 0 11-2.834 0c0-2.991 1.02-5.22 2.055-6.7A10.699 10.699 0 013.567.94a8.244 8.244 0 01.696-.584L4.28.344 4.286.34 4.29.338V.337S4.292.336 5.1 1.5L4.292.336a1.417 1.417 0 011.624 2.323m-.007.004zM21.559.439a1.417 1.417 0 012.002-.08c2.203 2.033 3.15 4.312 3.536 6.09.193.884.248 1.645.253 2.193a8.399 8.399 0 01-.041.915l-.003.02v.008l-.001.004v.001s0 .002-1.405-.19l1.404.191a1.417 1.417 0 01-2.81-.374l.002-.014.008-.097a5.59 5.59 0 00.012-.436 8.057 8.057 0 00-.188-1.618c-.288-1.323-.992-3.044-2.69-4.61a1.417 1.417 0 01-.08-2.003z"}})])
          )
        }
      }
    